import * as streamingActions from '../actions/streaming';
import * as pmActions from '../actions/pm';

import { batch } from 'react-redux';

import {
    ROOM_CLIENT_LIST,
    ROOM_CLIENT_LOGIN,
    ROOM_CLIENT_UPDATE,
    ROOM_CLIENT_LOGOUT
} from '../constants/users'

import {
    PM_CONVERSATIONS,
    PM_CONVERSATION_CHANGED,
    PM_SESSION_START,
    PM_SESSION_ACCEPTED,
    PM_SESSION_DECLINED,
    PM_SESSION_REVOKED,
    PM_ACCESS_REQUEST,
    PM_ACCESS_CHANGE_ALLOWED,
    PM_ACCESS_CHANGE_DENIED,
    PM_ACCESS_CHANGE_UNDEFINED,
    PM_ACCESS_ALLOW,
    PM_ACCESS_DENY,
    PM_ACCESS_UNDEFINED,
    PM_MESSAGE,
    PM_REQUEST_CANCELLED,
    PM_HISTORY,
    PM_TYPING_NOTIFY,
    PM_CLEAR_TYPING_NOTIFY,
    PM_DELETE_HISTORY,
    PM_USER_UPDATE
} from '../constants/pm';

import {
    ROOM_LIST,
    ROOM_SWITCHED,
    ROOM_JOINED,
    ROOM_LEAVED,
    ROOM_DESTROYED,
    ROOM_UPDATED,
    ROOM_INACTIVE,
    ROOM_SUBSCRIPTION_PAYMENT_FAILED
} from '../constants/rooms';

import {BobTVUser} from '../components/bobtv-neo/BobTVUser/index';

import {
    ROOM_MESSAGE,
    STATUS_MOTD
} from '../constants/roomMessages';

import { SIDEBAR_RIGHT_HIDE } from '../constants/sidebars';

import {SERVICE_MESSAGE} from '../constants/serviceMessage';
import {CLOSE, DISCONNECT, LOGIN_SUCCESS, LOGIN_NOT_ALLOWED, PRECONNECT, PRELOGIN} from '../constants/general';

import {
    ANONYMOUS_NICK_ALREADY_EXISTS,
    BLACKLISTED_REASON,
    BLOCKED_REASON,
    EXCLUDED_REASON,
    NONEXISTENT_ROOM_REASON,
    ROOM_INACTIVE_REASON,
    TOO_MANY_USERS_REASON,
    PAYMENT_REQUIRED,
    INSUFFICIENT_FUNDS
} from "../constants/chatInterface";

export default function reduxBind(store, chatInterface) {
    let currentUser = {uid: null};
    // Extending chat interface
    chatInterface.storeDispatch = function(action) {
        this.storeAddToBatch(action);
        this.batchDispatch();
    }

    chatInterface.storeAddToBatch = function(action) {
        this.batch.push(action);
    }

    chatInterface.batchDispatcher = function() {
        for (let i in this.batch) {
           this.store.dispatch(this.batch[i]);
        }
    }

    chatInterface.batchDispatch = function() {
        if (this.batch.length == 1) {
            this.store.dispatch(this.batch[0]);
        } else if (this.batch.length == 0) {
            return;
        } else {
            batch(this.batchDispatcherFn);    
        }
        
        this.batch = [];
    }

    // Initializing extended chatInterface
    chatInterface.store = store;
    chatInterface.batch = [];
    chatInterface.batchDispatcherFn = chatInterface.batchDispatcher.bind(chatInterface);

    if (chatInterface.batchInterval) {
        clearInterval(chatInterface.batchInterval);
    }

    chatInterface.batchInterval = setInterval(chatInterface.batchDispatch.bind(chatInterface), 10000);


    chatInterface.onPreLogin(function() { chatInterface.storeDispatch({type: PRELOGIN}) });

    chatInterface.onLoginSuccess(function(User) {
        let {room, ...userData} = User;

        let {creator, creator_nick, ...roomData} = room;

        currentUser = new BobTVUser({...userData, online: true});
        chatInterface.storeDispatch({
            type: LOGIN_SUCCESS,
            user: currentUser,
            room: {
                ...roomData,
                creator: new BobTVUser({uid: creator, nick: creator_nick})
            }
        })
    });

    chatInterface.onLoginError(function (Code, Reason, Data) {
        if (Reason === TOO_MANY_USERS_REASON) {
            chatInterface.storeDispatch({type: DISCONNECT});
        }

        if (Reason === ROOM_INACTIVE_REASON) {
            chatInterface.storeDispatch({type: ROOM_INACTIVE});
        }

        if (Reason === BLOCKED_REASON) {
            chatInterface.storeDispatch({type: LOGIN_NOT_ALLOWED});
        }

        if (Reason === EXCLUDED_REASON) {
            chatInterface.storeDispatch({type: LOGIN_NOT_ALLOWED});
        }

        if (Reason === BLACKLISTED_REASON) {
            chatInterface.storeDispatch({type: LOGIN_NOT_ALLOWED});
        }

        if (Reason === NONEXISTENT_ROOM_REASON) {
            chatInterface.storeDispatch({type: LOGIN_NOT_ALLOWED});
        }

        if (Reason === ANONYMOUS_NICK_ALREADY_EXISTS) {
            chatInterface.storeDispatch({type: LOGIN_NOT_ALLOWED});
        }

        if (Reason === PAYMENT_REQUIRED) {
            chatInterface.storeDispatch({type: PAYMENT_REQUIRED, data: Data});
        }

        if (Reason === INSUFFICIENT_FUNDS) {
            chatInterface.storeDispatch({type: INSUFFICIENT_FUNDS, data: Data});
        }

    });

    chatInterface.onClose(function() { chatInterface.storeDispatch({type: CLOSE}) });
    chatInterface.onDisconnect(function() { chatInterface.storeDispatch({type: DISCONNECT}) });
    chatInterface.onPreReconnect(function() { chatInterface.storeDispatch({type: PRECONNECT}) });

    chatInterface.onRoomClientList(function(Data) {
        chatInterface.storeDispatch({
            type: ROOM_CLIENT_LIST,
            roomid: Data.roomid,
            list: Data.users.map(function(hitagiChatUser) { return new BobTVUser({...hitagiChatUser, online: true}) })
        });
    });
    chatInterface.onRoomClientLogin(function(User) { chatInterface.storeAddToBatch({type: ROOM_CLIENT_LOGIN, roomid: User.roomid, user: new BobTVUser({...User, online: true})}) });
    chatInterface.onRoomClientUpdate(function(User) {
        let event = {
            type: ROOM_CLIENT_UPDATE,
            roomid: User.roomid,
            user: new BobTVUser({...User, online: true})
        };
        if (User.uid == currentUser.uid) {
            chatInterface.storeDispatch(event);
        } else {
            chatInterface.storeAddToBatch(event);
        }
        
    });

    chatInterface.onRoomClientLogout(function(User) { chatInterface.storeAddToBatch({type: ROOM_CLIENT_LOGOUT, roomid: User.roomid, user: new BobTVUser(User)}) });

    chatInterface.onStatusMotd(function(Data) { chatInterface.storeDispatch({type: STATUS_MOTD, data: Data, roomid: Data.roomid}) });
    chatInterface.onRoomMessage(function(Message) { chatInterface.storeDispatch({type: ROOM_MESSAGE, message: Message}) });
    chatInterface.onServiceMessage(function(ServiceMessage) { chatInterface.storeDispatch({type: SERVICE_MESSAGE, message: ServiceMessage}) });

    chatInterface.onStreamViewStart(function(StreamId, Ufrag, StreamObject) { chatInterface.storeDispatch(streamingActions.viewUserSuccess( StreamId, Ufrag, StreamObject )) });
    chatInterface.onStreamViewStop(function(Ufrag, Reason) { chatInterface.storeDispatch(streamingActions.viewUserStop(Ufrag, Reason)) });
    chatInterface.onStreamViewReconnect(function(Ufrag, StreamObject) { chatInterface.storeDispatch(streamingActions.viewUserReconnect( Ufrag, StreamObject )) });
    chatInterface.onStreamLeave(function(Ufrag) { chatInterface.storeDispatch(streamingActions.viewLeave( Ufrag )) });
    chatInterface.onStreamWatchingMe(function(Args) { chatInterface.storeDispatch(streamingActions.watchingMe( Args.ufrag, Args.watching )) });
    chatInterface.onStreamWatcherCount(function(Args) { chatInterface.storeDispatch(streamingActions.watcherCount( Args )) });
    chatInterface.onStreamStreamUpdate(function(Args) { chatInterface.storeDispatch(streamingActions.streamUpdate( Args )) });
    chatInterface.onStreamLimitReached(function() { chatInterface.storeDispatch(streamingActions.streamLimitReached()) });
    chatInterface.onStreamingStartSuccess(function(OwnStreamObject) { chatInterface.storeDispatch(streamingActions.streamingStartSuccess( OwnStreamObject )) });
    chatInterface.onStreamingStartError(function(Code, Reason) { chatInterface.storeDispatch(streamingActions.streamingStartError(Code, Reason)) });


    chatInterface.pm.onPmConversations(function (Data) { chatInterface.storeDispatch({type: PM_CONVERSATIONS, data: Data}) } );
    chatInterface.pm.onPmConversationChanged(function (Data) { chatInterface.storeDispatch({type: PM_CONVERSATION_CHANGED, conversation_uid: Data.recipient_uid, data: Data}) } );
    chatInterface.pm.onPmSessionStart(function(User){ chatInterface.storeDispatch(pmActions.startPmSession(User)) });

    chatInterface.pm.onPmUserUpdate(function(Data) {
//        console.log("triggering pm user update handler", Data)
        chatInterface.storeDispatch({type: PM_USER_UPDATE, user: Data.user, conversation_uid: Data.user.uid});
    })

    // client-originated actions
    chatInterface.pm.onPmSessionAccepted(function(Uid){ chatInterface.storeDispatch({type: PM_SESSION_ACCEPTED, uid: Uid, conversation_uid: Uid } ) });
    chatInterface.pm.onPmSessionDeclined(function(Uid){ chatInterface.storeDispatch({type: PM_SESSION_DECLINED, uid: Uid, conversation_uid: Uid }) });
    chatInterface.pm.onPmRequestCancelled(function(Uid){ chatInterface.storeDispatch({type: PM_REQUEST_CANCELLED, uid: Uid, conversation_uid: Uid }) });
    chatInterface.pm.onPmSessionRevoked(function(Uid){ chatInterface.storeDispatch({type: PM_SESSION_REVOKED, uid: Uid, conversation_uid: Uid }) });

    // server-originated actions
    chatInterface.pm.onPmAccessRequest(function(Request){ chatInterface.storeDispatch({type: PM_ACCESS_REQUEST, conversation_uid: Request.from_uid, request: Request}) });
    chatInterface.pm.onPmAccessChangeAllowed(function(Info){ chatInterface.storeDispatch({type: PM_ACCESS_CHANGE_ALLOWED, info: Info}) });
    chatInterface.pm.onPmAccessChangeDenied(function(Info){ chatInterface.storeDispatch({type: PM_ACCESS_CHANGE_DENIED, info: Info}) });
    chatInterface.pm.onPmAccessChangeUndefined(function(Info){ chatInterface.storeDispatch({type: PM_ACCESS_CHANGE_UNDEFINED, info: Info}) });
    chatInterface.pm.onPmHistory(function(History){ chatInterface.storeDispatch({type: PM_HISTORY, history: History}) });

    chatInterface.pm.onPmMessage(function(Message){
        var loggedInUser = chatInterface.getLoggedInUser();
        let recipient_uid = Message.receiver_uid ? Message.receiver_uid : Message.recipient_uid;
        let uid = Message.sender_uid !== loggedInUser.uid ? Message.sender_uid : recipient_uid;
        chatInterface.storeDispatch({type: PM_MESSAGE, message: Message, conversation_uid: uid, uid: uid}) });

    chatInterface.pm.onTypingNotify(function(Notify){
//console.log("onTypingNotify", Notify, state.pmSessions);
  //      if (state.pmSessions && state.pmSessions.hasOwnProperty(Notify.from) && state.pmSessions[Notify.from].maximized) {
        chatInterface.storeDispatch({ type: PM_TYPING_NOTIFY, notification: Notify, conversation_uid: Notify.from });
        setTimeout(function () {
            chatInterface.storeDispatch({ type: PM_CLEAR_TYPING_NOTIFY, conversation_uid: Notify.from })
        }, 5000)
    });

    chatInterface.pm.onDeleteHistory(function(DeleteHistory) {
        chatInterface.storeDispatch({ type: PM_DELETE_HISTORY, deleteHistory: DeleteHistory, conversation_uid: DeleteHistory.from_uid });
        chatInterface.storeDispatch({ type: SIDEBAR_RIGHT_HIDE });
    });



    chatInterface.onRoomList(function(List) {chatInterface.storeDispatch({type: ROOM_LIST, list: List}) });
    chatInterface.onRoomSwitched(function(Name) {chatInterface.storeDispatch({type: ROOM_SWITCHED, name: Name}) });
    chatInterface.onRoomJoined(function(Roomid) {chatInterface.storeDispatch({type: ROOM_JOINED, roomid: Roomid}) });
    chatInterface.onRoomLeaved(function(Roomid) {chatInterface.storeDispatch({type: ROOM_LEAVED, roomid: Roomid}) });
    chatInterface.onRoomDestroyed(function(Roomid) {chatInterface.storeDispatch({type: ROOM_DESTROYED, roomid: Roomid}) });
    chatInterface.onRoomUpdated(function(Room) {
        let RoomInfo = {
            ...Room,
               creator: new BobTVUser({uid: Room.creator, nick: Room.creator_nick})
        }
        chatInterface.storeDispatch({type: ROOM_UPDATED, room: RoomInfo})
    });

    chatInterface.onRoomSubscriptionPaymentFailed(function(Args) {chatInterface.storeDispatch({type: ROOM_SUBSCRIPTION_PAYMENT_FAILED, roomid: Args.roomid, error_code: Args.error_code, error_msg: Args.error_msg})} )
}


// WEBPACK FOOTER //
// ./src/bindings/chatinterface-redux.js